import React, { useState } from 'react';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import toast from 'react-hot-toast';

import {
  AddKnowledgeDocumentRequest,
  KnowledgeService,
} from 'us-web-services';
import DisplayService from '../../util/DisplayService';
import PageStyles from '../../styles/PageStyles';

function KnowledgeDocumentsAdd(props: RouteComponentProps) {
  const { history } = props;
  const [title, setTitle] = useState('');
  const [sourceType, setSourceType] = useState('');
  const [sourceUrl, setSourceUrl] = useState('');
  const [content, setContent] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { classes } = PageStyles();

  const cancel = () => {
    history.push('/knowledge-documents');
  };

  const addDocument = async () => {
    if (!title.trim()) {
      toast.error('Title is required');

      return;
    }

    if (!content.trim()) {
      toast.error('Content is required');

      return;
    }

    if (!sourceType.trim()) {
      toast.error('Source type is required');

      return;
    }

    const data: AddKnowledgeDocumentRequest = {
      title: title.trim(),
      content: content.trim(),
      sourceType: sourceType.trim(),
      sourceUrl: sourceUrl.trim() || null,
    };

    setIsSubmitting(true);

    try {
      await KnowledgeService.create(data);
      toast.success('Knowledge document successfully added');
      history.push('/knowledge-documents');
    } catch (error) {
      const displayed = DisplayService.getErrorResponse(
        error,
        'There was an error adding the knowledge document.',
      );

      toast.error(displayed.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Paper className={classes.paper}>
      <Typography variant='h5' gutterBottom>
        Add Knowledge Document
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            id='knowledge-doc-title'
            label='Title'
            variant='outlined'
            fullWidth
            required
            value={title}
            onChange={e => setTitle(e.target.value)}
            helperText='Display title for this knowledge document'
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='knowledge-doc-source-type'
            label='Source Type'
            variant='outlined'
            fullWidth
            required
            value={sourceType}
            onChange={e => setSourceType(e.target.value)}
            helperText='e.g. policy, howto, pricing, safety, community'
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='knowledge-doc-source-url'
            label='Source URL'
            variant='outlined'
            fullWidth
            value={sourceUrl}
            onChange={e => setSourceUrl(e.target.value)}
            helperText='Optional reference URL'
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='knowledge-doc-content'
            label='Content'
            variant='outlined'
            fullWidth
            required
            multiline
            minRows={10}
            value={content}
            onChange={e => setContent(e.target.value)}
            helperText='Body text used for embedding and retrieval'
          />
        </Grid>
      </Grid>
      <div className={classes.buttons} style={{ marginTop: 10 }}>
        <Button
          id='cancel'
          variant='contained'
          color='secondary'
          onClick={cancel}
          style={{ marginRight: 10 }}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button
          id='add-knowledge-document-button'
          variant='contained'
          color='primary'
          onClick={addDocument}
          disabled={isSubmitting}
        >
          Add Knowledge Document
        </Button>
      </div>
    </Paper>
  );
}

export default withRouter(KnowledgeDocumentsAdd);
